<template>
  <div class="bi-table-card stat-box">
    <div v-if="applicantsPage" class="bi-table-card--items">
      <div
        v-for="applicant of applicantsPage.results"
        :key="applicant.id"
        class="bi-table-card--item"
      >
        <div class="bi-table-card--item-details">
          <router-link
            :to="{
              name: 'applicant.edit',
              params: { id: applicant.id }
            }"
            ><h5>
              <template v-if="applicant.salutation == `MR`">Herr</template>
              <template v-else-if="applicant.salutation == `MRS`"
                >Frau</template
              >
              <template v-else>-</template>
              {{ applicant.firstName }} {{ applicant.lastName }}
            </h5>
          </router-link>
          <p>
            <i class="fas fa-briefcase"></i>
            <template
              v-if="
                applicant.defaultProfile &&
                  applicant.defaultProfile.wantedOccupation
              "
              >{{ applicant.defaultProfile.wantedOccupation }}</template
            >
            <template v-else>Kein Wunschberuf</template>
          </p>
        </div>
        <div class="bi-table-card--item-source">
          <template v-if="applicant.source.name == 'Facebook'">
            <span class="channel fb" title="Facebook"
              ><feather-icon :icon="['fab', 'facebook-f']"
            /></span>
          </template>
          <template v-else-if="applicant.source.name == 'Google'">
            <span class="channel google" title="Google"
              ><feather-icon :icon="['fab', 'google']"/></span
          ></template>
          <template v-else-if="applicant.source.name == 'Cleverreach'">
            <span class="channel cr" title="Cleverreach"
              ><feather-icon :icon="['fal', 'mail-bulk']"/></span
          ></template>
          <template
            v-else-if="
              applicant.source.name == 'Webseite Select' ||
                applicant.source.name == 'Website'
            "
          >
            <span class="channel web" title="Webseite Select"
              ><feather-icon :icon="['far', 'desktop']"/></span
          ></template>
          <template v-else>
            <span class="channel" title="Sonstige"
              ><feather-icon :icon="['far', 'home-lg-alt']"/></span
          ></template>
        </div>
      </div>
    </div>
    <div class="bi-table-card-link">
      <router-link :to="{ name: 'applicant.overview' }" class="overview-link">
        Alle Bewerber anzeigen <i class="fal fa-arrow-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  props: {
    startDate: { required: false, type: Object },
    endDate: { required: false, type: Object }
  },
  apollo: {
    applicantsPage: {
      query: gql`
        query ApplicantsPage(
          $page: Int!
          $size: Int
          $filter: ApplicantFilter
        ) {
          applicantsPage(page: $page, size: $size, filter: $filter) {
            total
            results {
              id
              number
              salutation
              firstName
              lastName
              source {
                id
                name
              }
              group {
                id
                name
              }
              defaultProfile {
                id
                wantedOccupation
                state {
                  id
                  name
                }
                internalConsultant {
                  id
                  shorthandSymbol
                  firstName
                  lastName
                }
              }
              createdAt
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          page: 1,
          size: 8,
          filter: {
            createdAfter: this.startDate,
            createdBefore: this.endDate
          }
        };
      },
      update(data) {
        this.$emit("retrieved", data.applicantsPage.total);
        return data.applicantsPage;
      }
    }
  },
  watch: {
    startDate() {
      this.$apollo.queries["applicantsPage"].refetch();
    },
    endDate() {
      this.$apollo.queries["applicantsPage"].refetch();
    }
  }
};
</script>
